import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import SydLabel, { hookFormErrorAdapter } from '../../../../commonDesign/SydLabel'
import SydInput from '../../../../commonDesign/SydInput'
import SydTextArea from '../../../../commonDesign/SydTextArea'
import { buildValidationRules } from '../utils/fieldUtils'

function TextFieldEditor ({ field, control, form }) {
  const rules = buildValidationRules(field)
  const isRequired = field.validations?.required || field.required
  const isMultiline = field.editorType === 'textarea'

  return (
    <Controller
      name={field.id}
      control={control}
      rules={rules}
      render={({ field: hookField, fieldState }) => (
        <SydLabel
          label={field.label}
          required={isRequired}
          error={hookFormErrorAdapter(form, fieldState)}
          description={field.description}
        >
          {isMultiline ? (
            <SydTextArea
              {...hookField}
              placeholder={field.label}
              rows={field.rows || 4}
              maxLength={field.validationRules?.maxLength}
            />
          ) : (
            <SydInput
              {...hookField}
              type='input'
              placeholder={field.label}
            />
          )}
        </SydLabel>
      )}
    />
  )
}

TextFieldEditor.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    editorType: PropTypes.string,
    required: PropTypes.bool,
    rows: PropTypes.number,
    validations: PropTypes.object,
    validationRules: PropTypes.object
  }).isRequired,
  control: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
}

export default TextFieldEditor
